import { render, staticRenderFns } from "./DisplayClasses.vue?vue&type=template&id=6aadfd26"
import script from "./DisplayClasses.vue?vue&type=script&lang=ts"
export * from "./DisplayClasses.vue?vue&type=script&lang=ts"
import style0 from "./DisplayClasses.vue?vue&type=style&index=0&id=6aadfd26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports